import { useGtm } from "@gtm-support/vue-gtm";

function nettoyerParams(params) {
  return Object.keys(params)
    .filter((cle) => params[cle] != null)
    .reduce((acc, cle) => ({ ...acc, [cle]: params[cle] }), {});
}

export default function () {
  const gtmEvent = (category, action, label) => {
    const gtm = useGtm();
    gtm.trackEvent({
      event: "declenche-evenement-leads", // Event type [default = 'interaction'] (Optional)
      category: category,
      action: action,
      label: label,
      noninteraction: false, // Optional
    });
  };

  const gtmEventv4 = (params) => {
    const paramsEnvoyes = {
      event: "main_funnel",
      form_name: "formulaire_leads",
      origin: "leads",
      ...params,
    };

    if (!Array.isArray(window.dataLayer)) {
      console.warn("dataLayer non défini");
    }
    window.dataLayer?.push(nettoyerParams(paramsEnvoyes));
  };

  const gtmTrackView = (name, fullUrl, additionalEventData) => {
    const gtm = useGtm();
    gtm.trackView(name, fullUrl, additionalEventData);
  };
  return { gtmEvent, gtmTrackView, gtmEventv4 };
}
